module.exports = "/_next/static/images/loading_17-e328896a8b379c022d9a7729418df8f7.png";